import * as React from "react";
import styles from "./Eventlog.module.scss";

const Eventlog = ({ data }) => {
  const [columns, setColumns] = React.useState([])
  const [dataset, setDataset] = React.useState([])

  React.useEffect(() => {
    if (data) {
      setColumns(Object.keys(data))

      const d = Object.entries(data)?.map(([key, value]) => {
        return {
          count: value && Object.keys(value)?.length
        }
      })
      if (d) {
        const t = d.map(item => item.count)
        const max = Math.max(...t)
        const arr = []
        Object.entries(data)?.forEach(([key, value]) => {
          for (let i = 0; i < max; i++) {
            arr[i] = {
              ...arr[i],
              [key]: value[i]
            }
          }
        })
        setDataset(arr)
      }
    }
  },[data])

  return (
    <div className={'col-md-6 pl-1 pr-1'}>
      <div className={styles.eventLog}>
        <div className={styles.header}>
          <div className={styles.title}>
            Eventlog Table
          </div>
          <div className={styles.dropdown}>

          </div>
        </div>
        <div className={['container', styles.table].join(' ')}>
          <table>
            {
              columns.map(column => <th>{column}</th>)
            }
            {
              dataset.map(item => <tr>
                {
                  columns.map(column => <td>{ column !== "CASEID" && Number.isInteger(item[column]) ? item[column]?.toLocaleString() : item[column] }</td>)
                }
              </tr>)
            }
          </table>
        </div>
      </div>
    </div>
  )
}

export default Eventlog